module.exports = __webpack_public_path__ + "static/media/jeans.3330bc00.jpg";